import { Controller } from '@hotwired/stimulus'

// Shows/hides a sibling hint element when its trigger is hovered.
// Usage:
//   <div data-controller="hint-toggle">
//     <i data-action="mouseenter->hint-toggle#show mouseleave->hint-toggle#hide"></i>
//     <small class="d-none" data-hint-toggle-target="hint">...</small>
//   </div>
export default class extends Controller {
  static targets = ['hint']

  show() {
    this.hintTarget.classList.remove('d-none')
  }

  hide() {
    this.hintTarget.classList.add('d-none')
  }
}
